import { SyntheticEvent, useRef } from 'react'
import { Button } from 'primereact/button'
import { MenuItem } from 'primereact/menuitem'
import { Menu } from 'primereact/menu'

import { pi } from './pure/PrimeIcon'
import { capture } from '../../tools/dom/event'

interface TableContextMenuProps {
    menu: MenuItem[]
    className?: string
}
export default function CardContextMenu({ menu, className }: TableContextMenuProps) {
    const ref = useRef<Menu>(null)
    if (menu.length === 0) return null
    const toggle = (event: SyntheticEvent) => {
        event.stopPropagation()
        ref.current?.toggle(event)
    }
    return (
        <>
            <Button
                className={className ?? 'table-context-menu'}
                onClick={toggle}
                icon={pi('ellipsis-v')}
                severity="secondary"
                outlined
                text
            />
            <Menu model={menu} ref={ref} popup onClick={capture()} />
        </>
    )
}
